export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./recipe.vue?vue&type=template&id=16338bbc&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/recipe.vue?vue&type=template&id=16338bbc&
// module id = 90
// module chunks = 0